module.exports = __webpack_public_path__ + "img/one-id.74fb2712.svg";